import { common } from "../../shared/utils/UtilSaga";
import ApiService from "../../shared/services/ApiService";
import { call, delay, fork, put, race, takeLatest } from "redux-saga/effects";
import {
  FETCH_GROUP_ORDER_DASHBOARD,
  GROUP_ORDER_DASHBOARD_USER_DATA,
  GROUP_ORDER_DATA,
  IS_LOADING_GROUP_ORDER,
  JOINED_GROUP_ORDER,
  UPDATE_GROUP_ORDER_ITEM,
} from "./GroupOrder.constant";

function* workerGroupOrderDashboard(action) {
  const { ...props } = action.payload;
  yield put({ type: IS_LOADING_GROUP_ORDER, payload: true });
  try {
    const { response } = yield race({
      response: call(
        ApiService.groupOrderDashboard.fetchGroupOrderDashboard,
        props
      ),
      timeout: delay(15000),
    });
    if (response) {
      yield put({ type: GROUP_ORDER_DATA, payload: response });
      // yield put({ type: GROUP_ORDER_DASHBOARD_USER_DATA, payload:response?.user });
    }
  } finally {
    yield put({ type: IS_LOADING_GROUP_ORDER, payload: false });
  }
}
function* workerUpdateJoined(action) {
  const { history, slug_uuid, isSundayTeamLunch, ...payload } = action.payload;
  if (isSundayTeamLunch) {
    yield put({ type: IS_LOADING_GROUP_ORDER, payload: false });
    history.push("/sunday-team-lunch");
    return;
  }
  yield put({ type: IS_LOADING_GROUP_ORDER, payload: true });
  try {
    const { data } = yield race({
      data: call(
        ApiService.groupOrderDashboard.joinedGroupOrderApi,
        payload
      ),
      timeout: delay(15000),
    });
    if (data) {
      if (data.id) {
        localStorage.setItem("GroupOrderMemberID", data.id);
      }
      history.push(
        `/group_order/${payload.slug || payload.id}${slug_uuid ? `?creator_id=${slug_uuid}` : ""}`
      );
    }
  } finally {
    yield put({ type: IS_LOADING_GROUP_ORDER, payload: false });
  }
}
function* watchUpdateJoined() {
  yield takeLatest(JOINED_GROUP_ORDER, common(workerUpdateJoined));
}
function* watchGroupOrderDashboard() {
  yield takeLatest(
    FETCH_GROUP_ORDER_DASHBOARD,
    common(workerGroupOrderDashboard)
  );
}

export default function groupOrderDashboardWatchers() {
  return [fork(watchGroupOrderDashboard), fork(watchUpdateJoined)];
}
